import React from 'react';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';

const style = {
  panelClassName: "row m-0",
  searchFiltersRowClassName: "row m-0",
  searchColumnClassName: "col-sm-4",
  buttonsRowClassName: "row search-buttons"
}

const searchFields = (props) => {
    return (
        <div className={style.panelClassName}>
            <div className={style.searchFiltersRowClassName}>   
                <div className={style.searchColumnClassName}>
                    <DatePickerInput
                        name={`${props.pageName}StartDateFilter`}
                        className="search-field"
                        label={LOOKUP.bankdeposits.filters.startDate.label}
                        floatingLabelText={LOOKUP.bankdeposits.filters.startDate.label}
                        hintText={LOOKUP.bankdeposits.filters.startDate.hintText}
                        onPressKey={props.search}
                        />
                </div>
                <div className={style.searchColumnClassName}>
                    <DatePickerInput
                        name={`${props.pageName}EndDateFilter`}
                        className="search-field"
                        label={LOOKUP.bankdeposits.filters.endDate.label}
                        floatingLabelText={LOOKUP.bankdeposits.filters.endDate.label}
                        hintText={LOOKUP.bankdeposits.filters.endDate.hintText}
                        onPressKey={props.search}
                        />
                </div>
                <div className={style.searchColumnClassName}>
                    <DatePickerInput
                        name={`${props.pageName}DepositDateFilter`}
                        className="search-field"
                        label={LOOKUP.bankdeposits.filters.depositDate.label}
                        floatingLabelText={LOOKUP.bankdeposits.filters.depositDate.label}
                        hintText={LOOKUP.bankdeposits.filters.depositDate.hintText}
                        onPressKey={props.search}
                        />
                </div>
                <div className={style.searchColumnClassName}>
                    <DecimalInput
                        name={`${props.pageName}AmountFilter`}
                        type="number"
                        className="search-field"
                        label={LOOKUP.bankdeposits.filters.amount.label}
                        floatingLabelText={LOOKUP.bankdeposits.filters.amount.label}
                        hintText={LOOKUP.bankdeposits.filters.amount.hintText}
                        onPressKey={props.search}/>
                </div>
                {/* <div className={style.searchColumnClassName}>
                    <TextInput name={`${props.pageName}UserFilter`}
                        className="search-field"
                        label={LOOKUP.bankdeposits.filters.logUserId.label}
                        floatingLabelText={LOOKUP.bankdeposits.filters.logUserId.label}
                        hintText={LOOKUP.bankdeposits.filters.logUserId.hintText}
                        maxLength={500}
                        onPressKey={props.search} />
                </div> */}
                <div className={style.searchColumnClassName}>
                    <TextInput
                        name={`${props.pageName}ReferenceFilter`}
                        className="search-field"
                        label={LOOKUP.bankdeposits.filters.referenceCode.label}
                        floatingLabelText={LOOKUP.bankdeposits.filters.referenceCode.label}
                        hintText={LOOKUP.bankdeposits.filters.referenceCode.hintText}
                        maxLength={500}
                        onPressKey={props.search}/>
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                 <BranchMultiSelectAutoCompleteInput
                  defaultValues={props.defaultBranchValues}
                  name="BankDepositListBranchIds" 
                  label="Branches"
                  floatingLabelText="Branches"
                  hintText="Select Branches"
              />
           </div>
         <div className={style.buttonsRowClassName}>
                <div className="col-lg-12 text-right pt-2">
                    <Button
                        type="IconSearchButton"
                        mini={true}
                        label={LOOKUP.bankdeposits.filters.filterButton}
                        onTouchTap={() => props.search()}
                        className="btnNewBrandPOS mr-1"
                    />
                    <Button
                        className="btnCleanSearch"
                        type="IconClearButton"
                        label={LOOKUP.bankdeposits.filters.cleanFilterButton}
                        onTouchTap={() => props.cleanSearch()}
                    />
                      <Button
                        type="DownloadButton"
                        className="pull-right ml-1 btnNewBrandPOS"
                        name={props.pageName + LOOKUP.report.common.downloadReport.name}
                        label={LOOKUP.report.common.downloadReport.label}
                        onTouchTap={() => props.downloadReport()}
                    />

                </div>
            </div>
        </div>
    );
};

export default searchFields;
